import { isDev } from '@/config/env'
import { logServerError } from '@/server/logger'

import * as RUMService from './RUM'

const isServer = () => typeof window === 'undefined'

export const reportError = (error: unknown, extra?: Record<string, unknown>) => {
  if (isDev()) {
    console.error(error, extra)
    return
  }
  if (isServer()) {
    logServerError(
      typeof extra?.context === 'string' ? extra.context : 'Server error',
      error,
      extra
    )
    return
  }
  RUMService.reportError(error, extra)
}

export const reportErrorMessage = (message: string, extra?: Record<string, unknown>) => {
  if (isDev()) {
    console.error(message, extra)
    return
  }
  if (isServer()) {
    logServerError(message, undefined, extra)
    return
  }

  RUMService.reportError(message, extra)
}

export const reportWarning = (message: string) => {
  console.error(message)
}
